import type { ReactNode } from 'react';
import { AppDownloadProvider } from './AppDownloadModal';
import { Header } from './Header';
import { Footer } from './Footer';
import { cn } from '~/lib/cn';
import { SiteAvailabilityProvider } from '~/lib/useSiteAvailability';

export function PageShell({
  children,
  headerTransparentUntilScroll = false,
  footerClassName,
  showFooterLegalDisclosure = true,
}: {
  children: ReactNode;
  /**
   * Opt-in: header is transparent over the hero at the top of the page and
   * fades to solid white on scroll (see `Header`). Defaults to the always-white
   * sticky header used by every other page.
   */
  headerTransparentUntilScroll?: boolean;
  /** Extra classes on `<Footer>` (e.g. homepage `mt-[20rem]` for the card hand). */
  footerClassName?: string;
  /** Whether the regulatory disclosure block is shown below the footer navigation. */
  showFooterLegalDisclosure?: boolean;
}) {
  return (
    <SiteAvailabilityProvider>
      <AppDownloadProvider>
        <div className="flex min-h-screen flex-col">
          <Header transparentUntilScroll={headerTransparentUntilScroll} />
          {/* When the header floats transparent, pull the content up under it (by
              the header's h-16 height) so the first section's background reaches
              the very top of the page and sits *behind* the transparent bar —
              otherwise the sticky header leaves a white strip + seam above the
              hero. The page's hero is responsible for enough top padding to clear
              the 64px header (see send-money-home). */}
          <main className={cn('flex-1', headerTransparentUntilScroll && '-mt-16')}>{children}</main>
          <Footer className={footerClassName} showLegalDisclosure={showFooterLegalDisclosure} />
        </div>
      </AppDownloadProvider>
    </SiteAvailabilityProvider>
  );
}
